import {Component, HostListener, Input} from "@angular/core";
import {Subscription} from "rxjs/internal/Subscription";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";

@Component({
    selector: "app-modal-wrapper",
    templateUrl: "modal-wrapper.component.html"
})
export class ModalPaymentWrapperComponent {
    open = false;
    subscription: Subscription;

    @Input() title: string;

    constructor(private modalService: ModalPaymentService) {
        this.subscription = modalService.modalState$.subscribe((value) => {
            this.open = value;
        });
    }

    close() {
        this.open = false;
        this.modalService.close();
    }

    @HostListener("document:keyup", ["$event"])
    handleKeyUp(event: KeyboardEvent) {
        if (event.keyCode === 27 && this.open) {
            this.close();
        }
    }
}
